
<script>

import Settings from '@/config/Settings'
import * as THREE from 'three'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js'
import { GlitchPass } from 'three/examples/jsm/postprocessing/GlitchPass.js'
import { Vertex, Fragment } from './shaders/Shader.js'

export default {
  name: 'BloomPass',
  components: {},
  data: ()=>({
    exposure: 1,
    bloomStrength: 0.0,
    bloomThreshold: 0.0,
    bloomRadius: 1.0,
    darkMaterial : new THREE.MeshBasicMaterial( { color: "black" } ),
    materials: {},
  }),

  created() {
    this.$glb = this.$parent.$glb
    this.$renderer = this.$parent.$renderer
    this.$scene = this.$parent.$scene
    this.$camera = this.$parent.$camera
  },

  mounted() {

    this.$bloomLayer = new THREE.Layers()
    this.$bloomLayer.set( Settings.BLOOM_SCENE )

    this.$glb.scene.traverse((child)=>{
      if(child.name == 'SM_Pavillon_VIP_Door') 
        child.layers.toggle(Settings.BLOOM_SCENE)
    })

    this.$renderScene = new RenderPass(this.$scene, this.$camera)
    this.bloomPass = new UnrealBloomPass( new THREE.Vector2( window.innerWidth, window.innerHeight ), 1.5, 0.4, 0.85 )
          this.bloomPass.threshold = this.bloomThreshold
          this.bloomPass.strength = this.bloomStrength
          this.bloomPass.radius = this.bloomRadius

    this.$bloomComposer = new EffectComposer( this.$renderer )
    this.$bloomComposer.setSize( window.innerWidth, window.innerHeight )
    this.$bloomComposer.renderToScreen = false
    this.$bloomComposer.addPass( this.$renderScene )
    this.$bloomComposer.addPass( this.bloomPass )

    const finalPass = new ShaderPass(
      new THREE.ShaderMaterial( {
        uniforms: {
          baseTexture: { value: null },
          bloomTexture: { value: this.$bloomComposer.renderTarget2.texture }
        },
        vertexShader: Vertex,
        fragmentShader: Fragment,
        defines: {}
      } ), "baseTexture"
    )
    finalPass.needsSwap = true

    this.$finalComposer = new EffectComposer( this.$renderer )
    this.$finalComposer.setSize( window.innerWidth, window.innerHeight )
    this.$finalComposer.addPass( this.$renderScene )
    this.$finalComposer.addPass( finalPass )

    this.render()
  },

  methods:{
    render(){
      this.renderBloom(true)
      this.$finalComposer.render()
    },
    disposeMaterial( obj ) {
      if ( obj.material ) {
        obj.material.dispose()
      }
    },
    renderBloom( mask ) {
      if ( mask === true ) {
        this.$scene.traverse( this.darkenNonBloomed )
        this.$bloomComposer.render()
        this.$scene.traverse( this.restoreMaterial )
      } else {
        this.$camera.layers.set( Settings.BLOOM_SCENE )
        this.$bloomComposer.render()
        this.$camera.layers.set( Settings.ENTIRE_SCENE )
      }
    },
    darkenNonBloomed( obj ) {
      if ( obj.isMesh && this.$bloomLayer.test( obj.layers ) === false ) {
        this.materials[ obj.uuid ] = obj.material
        obj.material = this.darkMaterial
      }
    },
    restoreMaterial( obj ) {
      if ( this.materials[ obj.uuid ] ) {
        obj.material = this.materials[ obj.uuid ]
        delete this.materials[ obj.uuid ]
      }
    },
    updateBloom(bloom) {
      this.bloomPass.strength = bloom
    },
  }

}
</script>




